import { render, staticRenderFns } from "./SelectTreatment.vue?vue&type=template&id=58ffbe78&scoped=true&lang=pug"
import script from "./SelectTreatment.vue?vue&type=script&lang=js"
export * from "./SelectTreatment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ffbe78",
  null
  
)

export default component.exports